(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grandedu-mba-credit-check"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      document.querySelectorAll('[data-ghb-credit-check]').forEach((root) => {
        if (root.dataset.creditReady === 'true') return;
        root.dataset.creditReady = 'true';

        const page = root.closest('.ghb-page--grandedu');
        const story = page ? page.querySelector('.ghb-story') : null;
        if (story && story.nextElementSibling !== root) story.insertAdjacentElement('afterend', root);

        const choices = Array.from(root.querySelectorAll('[data-credit-choice]'));
        const modules = Array.from(root.querySelectorAll('[data-credit-module]'));
        const ectsValue = root.querySelector('[data-credit-ects]');
        const moduleValue = root.querySelector('[data-credit-modules]');
        const remainingValue = root.querySelector('[data-credit-remaining]');
        const progress = root.querySelector('[data-credit-progress]');
        const progressBar = root.querySelector('[data-credit-progress-bar]');

        const update = (choice) => {
          const selected = new Set(choice.dataset.modules.split(',').filter(Boolean));
          let credits = 0;

          choices.forEach((button) => button.setAttribute('aria-pressed', button === choice ? 'true' : 'false'));

          modules.forEach((card) => {
            const active = selected.has(card.dataset.creditModule);
            card.classList.toggle('is-credit', active);
            const state = card.querySelector('[data-credit-state]');
            if (state) state.textContent = active ? root.dataset.selectedLabel : root.dataset.unselectedLabel;
            if (active) credits += Number(card.dataset.creditEcts);
          });

          const remaining = Math.max(0, 120 - credits);
          if (ectsValue) ectsValue.textContent = credits + ' ECTS';
          if (moduleValue) moduleValue.textContent = selected.size;
          if (remainingValue) remainingValue.textContent = remaining + ' ECTS';
          if (progress) progress.setAttribute('aria-valuenow', credits);
          if (progressBar) progressBar.style.width = (credits / 120 * 100) + '%';
        };

        choices.forEach((choice) => choice.addEventListener('click', () => update(choice)));
        if (choices[0]) update(choices[0]);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
